import { render, staticRenderFns } from "./MainBannerAndDescription.vue?vue&type=template&id=d83b3ca8&scoped=true"
import script from "./MainBannerAndDescription.vue?vue&type=script&lang=ts"
export * from "./MainBannerAndDescription.vue?vue&type=script&lang=ts"
import style0 from "./MainBannerAndDescription.vue?vue&type=style&index=0&id=d83b3ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83b3ca8",
  null
  
)

export default component.exports